import { IFormatVersion } from "./FormatVersion";
import { IFormatOrganization } from "./FormatOrganization";
import { ICanvasBannerPlaceholderFormat } from "./CanvasBannerPlaceholderFormat";

export interface IFormat {
    id?: string;
    displayTitle?: string;
    description?: string;
    dateCreated?: Date;
    isPublished?: boolean;
    formatVersions?: IFormatVersion[];
    specificallySelectOrganizations: IFormatOrganization[];
    formatType?: FormatType;
    canvasBannerPlaceholderFormats?: ICanvasBannerPlaceholderFormat[];
    shouldSendUnloadEvent?: boolean;
}

export class Format implements IFormat {
    id?: string;
    displayTitle?: string;
    description?: string;
    dateCreated?: Date;
    isPublished?: boolean;
    formatVersions?: IFormatVersion[];
    specificallySelectOrganizations: IFormatOrganization[];
    formatType?: FormatType;
    canvasBannerPlaceholderFormats?: ICanvasBannerPlaceholderFormat[];
    shouldSendUnloadEvent?: boolean;

    constructor();
    constructor(obj: IFormat);
    constructor(obj?: IFormat) {
        this.id = obj && obj.id || undefined;
        this.displayTitle = obj && obj.displayTitle || undefined;
        this.description = obj && obj.description || undefined;
        this.dateCreated = obj && obj.dateCreated || undefined;
        this.isPublished = obj && obj.isPublished || undefined;
        this.formatVersions = obj && obj.formatVersions || undefined;
        this.specificallySelectOrganizations = obj && obj.specificallySelectOrganizations || undefined;
        this.formatType = obj?.formatType || undefined;
        this.canvasBannerPlaceholderFormats = obj?.canvasBannerPlaceholderFormats || undefined;
        this.shouldSendUnloadEvent = obj && obj.shouldSendUnloadEvent || undefined;
    }
}

export enum FormatType {
    BANNER = 1,
    CANVAS = 2,
    CANVAS_MOBILE = 3,
}

export const FORMAT_VALIDATION_RULES: {
    title: ((v: any) => any)[],
    description: ((v: any) => any)[],
    formatid: ((v: any) => any)[],
    width: ((v: any) => any)[],
    height: ((v: any) => any)[],
} = {
    title: [
        v => !!v || 'Title is required',
        v => !!v && v.length <= 80 || 'Title cannot contain more than 80 characters'
    ],
    description: [
        v => !!v || 'Description is required',
    ],
    formatid: [
        v => !!v || 'Format Id is required',
        v => !!v && v.length <= 80 || 'Format Id cannot contain more than 80 characters',
        v => {
            let rule = /^[a-zA-Z0-9\-\_]+$/;
            return !!v && rule.test(v) || 'Format Id'
        }
    ],
    width: [
        v => !!v && v.length > 0 || 'Width is required',
        v => {
            let rule = /^[\d]*(%|px)$/;
            return !!v && rule.test(v) || 'Width has to be numeric and end with either % or px.'
        }
    ],
    height: [
        v => !!v && v.length > 0 || 'Height is required',
        v => {
            let rule = /^[\d]*(%|px)$/;
            return !!v && rule.test(v) || 'Height has to be numeric and end with either % or px.'
        }
    ],
};